export function findInstitution(state) {
  return (id) => state.all.find(((v) => v.id === id));
}
